// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CouponTooltip_wrapper__M_7HA","hide":"CouponTooltip_hide__nCoAx"};